module.exports = __webpack_public_path__ + "static/media/user-default.4d798d16.svg";